<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <div class="row ps-5 pe-5 pt-4">
            <div class="col-sm-5">
                <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Ümumi məlumat</p>
                <br>
                <div class="row">
                    <el-form-item label="Təklif tarixi" class="w-50" prop="quotaDate" label-position="top">
                        <el-date-picker format="DD.MM.YYYY" v-model="values.quotaDate" class="w-100" type="date"
                            placeholder="Pick a day" />
                    </el-form-item>
                </div>
                <div class="row">
                    <el-form-item label="Təklif Nömrəsi" class="w-50" label-position="top">
                        <el-input v-model="values.quotaFullNumber" />
                    </el-form-item>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <el-form-item label="Müddət(ay)" prop="period" label-position="top">
                            <el-input-number v-model="values.period" :min="36" class="w-100" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-3">
                        <el-form-item label="Valyuta" label-position="top">
                            <currency :propvalue="values.currencyId" @change-value="value => values.currencyId = value">
                            </currency>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item label="Baş Müqavilə Nömrəsi" label-position="top">
                            <el-input v-model="values.generalFullNumber" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Baş Müqavilə tarixi" prop="quotaDate" label-position="top">
                            <el-date-picker format="DD.MM.YYYY" v-model="values.generalDate" class="w-100" type="date"
                                placeholder="Pick a day" />
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item disabled="true" label="Sığorta haqqının ödənilmə qaydası"
                            label-position="top">
                            <el-select v-model="values.payType">
                                <el-option label="Aylıq" value="1" />
                                <el-option label="Birdəfəlik" value="2" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <br>
                <div>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Məsul şəxslər</p>

                    <br>
                    <div class="row">
                        <div class="col-sm-4">
                            <el-form-item label="Agent" label-position="top">
                                <el-select v-model="values.agentId">
                                    <el-option label="Vafa Abilova" value="1" />
                                    <el-option label="Kamran Məmmədli" value="2" />
                                    <el-option label="Leyla Həsənova" value="3" />
                                    <el-option label="Rauf Əliyev" value="4" />
                                    <el-option label="Aysel Quliyeva" value="5" />
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                            <el-form-item label="Anderayter" label-position="top">
                                <el-select v-model="values.underwritingId">
                                    <el-option label="Elvin Rzayev" value="1" />
                                    <el-option label="Nigar Əliyeva" value="2" />
                                    <el-option label="Samir Qasımov" value="3" />
                                    <el-option label="Sevda Hacıyeva" value="4" />
                                    <el-option label="Orxan İsmayılov" value="5" />
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                            <el-form-item disabled="true" label="Kurator" label-position="top">
                                <el-select v-model="values.curatorId">
                                    <el-option label="Elvin Rzayev" value="1" />
                                    <el-option label="Nigar Əliyeva" value="2" />
                                    <el-option label="Samir Qasımov" value="3" />
                                    <el-option label="Sevda Hacıyeva" value="4" />
                                    <el-option label="Orxan İsmayılov" value="5" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-5 pe-6">
                <div>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Sığortalı</p>

                    <br>
                    <el-form-item label-position="top">
                        <partner-finder :onlyC="true" :propvalue="values.insured" :sector="true"
                            @change-value="value => values.insured = value">
                        </partner-finder>
                    </el-form-item>
                </div>
                <br>
                <div>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Ödəyici</p>

                    <br>
                    <el-form-item label-position="top">
                        <partner-finder :propvalue="values.holder" @change-value="value => values.holder = value">
                        </partner-finder>
                    </el-form-item>
                </div>
                <br>
            </div>
        </div>
        <br>
        <el-affix position="bottom" :offset="5">
            <div class="pe-5" style="background-color: white; display: flex; justify-content: end;">
                <soft-button @click="SubmitForm()" color="success">Növbəti ></soft-button>
            </div>
        </el-affix>
        <br>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue";
import Currency from "@/project/Components/Currency.vue";
import PartnerFinder from "@/project/Components/PartnerFinder.vue";

export default {
    components: {
        SoftButton,
        Currency,
        PartnerFinder
    },
    props: {
        object: Object,
        editing: Boolean,
        insert: Boolean,
    },
    data() {
        return {
            values: { quotaDate: new Date(), currencyId: "1", period: 36, payType: "1" },
            banks: [],
            companies: [],
            searched: false,
            rules: {
                period: [
                    { required: true, message: 'Mütləq sahə', trigger: 'blur' },
                    { type: 'number', min: 36, message: 'Minimum 36 ay', trigger: 'blur' }
                ]
            },
        }
    },
    mounted() {
        if (this.editing == true) {
            this.values = { ...this.object }
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    // window.location.href = window.location.origin + '/documents/quota/' + 3;
                    this.$emit('insert-dialog')
                }
            });
        },
    },
    watch: {
        'values.insured'() {
            this.values.holder = { ...this.values.insured }
        }
    }
}
</script>